
import {DataChunkDto, LoadDataBatchFiltersDto} from '../dtos/load-data-batch.dto';
import {DateTools} from '@selpia/shared/utils';
import {DataChunk, DataPoint, DimensionItem, Sentiment} from '@selpia/shared/models';

export class DTOsConverter {
  static buildFilters(filters: DimensionItem[], includeTotal: boolean, date?: Date | undefined): LoadDataBatchFiltersDto {
    const dtoFilters: LoadDataBatchFiltersDto = {};

    filters.forEach((filter) => {
      dtoFilters[filter.dimensionLevelName] = filter.code;
    });

    if (!includeTotal) {
      dtoFilters['includeTotal'] = 'false';
    }

    if (date) {
      dtoFilters['date'] = DateTools.getDateString(date);
    }

    return dtoFilters;
  }

  static dtoDataBatch(data: DataChunkDto[]): DataChunk[] {
    return data.map((dto, id): DataChunk => this.dtoToDataChunk(dto, id));
  }

  static dtoToDataChunk(dto: DataChunkDto, id?: number): DataChunk {
    const dataPoints: DataPoint[] = dto.dataPoints.map((dp): DataPoint => {
      const date = DateTools.createDate(dp.date);
      const sentiment: Sentiment = dp.sentiment || 0;

      return {
        ...dp,
        date,
        sentiment,
      } as DataPoint;
    });
    return {...dto, dataPoints, id};
  }
}
